import { apiDelete, apiGet, apiPost, apiPut } from './http'
import { downloadBlobResponse, normalizeBuildingQuery } from './helpers'

export const findAll = async (params = {}) =>
  apiGet('/account', {
    auth: true,
    config: { params: normalizeBuildingQuery(params) },
    fallbackMessage: 'Error al obtener las cuentas contables.',
  })

export const findById = async id =>
  apiGet(`/account/${id}`, {
    auth: true,
    fallbackMessage: 'Error al obtener la cuenta contable.',
  })

export const create = async payload =>
  apiPost('/account', payload, {
    auth: true,
    fallbackMessage: 'Error al crear la cuenta contable.',
  })

export const update = async ({ id, ...payload }) =>
  apiPut(`/account/${id}`, payload, {
    auth: true,
    fallbackMessage: 'Error al actualizar la cuenta contable.',
  })

export const remove = async id =>
  apiDelete(`/account/${id}`, {
    auth: true,
    fallbackMessage: 'Error al eliminar la cuenta contable.',
  })

export const nextCode = async (params = {}) =>
  apiGet('/account/next-code', {
    auth: true,
    config: { params: normalizeBuildingQuery(params) },
    fallbackMessage: 'Error al obtener el próximo código de cuenta.',
  })

export const downloadExcel = async payload => {
  const response = await apiPost('/docs/commonexpenses/xls', payload, {
    auth: true,
    rawResponse: true,
    config: { responseType: 'blob' },
    fallbackMessage: 'Error al descargar el archivo de cuentas.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, payload.fileName || 'cuentas', 'xlsx')
  return { ok: true }
}
